import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import SubscriptionExpiredContent from './SubscriptionExpiredContent';
import Image from '../../../atoms/images/Image';
import Paragraph from '../../../atoms/paragraphs/Paragraph';
import { UserService } from '../../../../services/UserService';
import { AppContext } from '../../../../contexts/AppContext';
import { SubscriptionService } from '../../../../services/SubscriptionService';
import Icon from '../../../atoms/icons/Icon';
import Bugsnag from '@bugsnag/js';

const SubscriptionExpiredPage = ({ intl, ...props }) => {
  const { appState } = useContext(AppContext);
  Bugsnag.notify(new Error(`App State: ${JSON.stringify(appState, null, 2)}`));
  const currentFlow = appState.accountTrial === 'true' ? 'trial' : 'client';
  const [userAccounts, setUserAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState({
    value: appState.rawAccount || '',
    key: 'Loading...',
  });
  const [subscriptionDetails, setSubscriptionDetails] = useState(undefined);

  const changeImpersonatedAccount = async (account_id) => {
    await UserService.changeCurrentAccount(appState.rawUser, account_id);
    window.location.href = '/home';
  };

  const handleAccountChange = (value) => {
    const selectedAccountObj = userAccounts.find(
      (account) => account.value.toString() === value.toString()
    );

    setSelectedAccount({
      value: selectedAccountObj.value,
      key: selectedAccountObj.key,
    });

    changeImpersonatedAccount(value);
  };

  useEffect(() => {
    const fetchUserAccounts = async () => {
      const response = await UserService.getUserAccounts(appState.rawUser);
      const accountsList = response.accounts.map((account) => {
        return {
          value: account.id,
          key: account.name,
        };
      });
      setUserAccounts(accountsList);

      // Find and set the selected account based on rawAccount, with null check
      if (appState.rawAccount) {
        const currentAccount = accountsList.find(
          (account) =>
            account.value &&
            account.value.toString() === appState.rawAccount.toString()
        );
        if (currentAccount) {
          setSelectedAccount(currentAccount);
        }
      }
    };
    fetchUserAccounts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      const response = await SubscriptionService.getSubscriptionDetails();

      if (!response.error) {
        setSubscriptionDetails(response.subscription);
      }
    };

    fetchSubscriptionDetails();
  }, []);

  return (
    <div className='d-flex flex-column blocked-layout'>
      <div className='d-flex flex-column w-100 blocked-layout__wrapper'>
        <div className='d-flex flex-column align-items-center w-100 my-auto'>
          <div
            className={`d-flex flex-column blocked-layout__container col-12 col-lg-10 col-xxl-8 px-0 overflow-hidden position-relative`}
          >
            <div className='d-flex flex-column blocked-layout__content h-100 overflow-auto'>
              <div className='d-flex flex-row justify-content-center align-items-center w-100'>
                <div className='d-flex flex-column h-100 w-100 align-items-center gap-3'>
                  {subscriptionDetails?.payment_status === 'on_hold' ? (
                    <div className='message-container pending d-flex flex-row col-12 px-0 mb-4'>
                      <div className='message-wrapper d-flex flex-grow-1 px-4 py-3'>
                        <Icon className='message-icon icon fas fa-2x fa-exclamation-triangle my-auto' />
                        <Paragraph className='text-paragraph message-text ps-3 my-0 mx-auto'>
                          {intl.messages['subscriptionPaymentStatusPendingAlt']}
                        </Paragraph>
                      </div>
                    </div>
                  ) : null}
                  <Image
                    src='https://invoicexpress-assets.s3.eu-west-1.amazonaws.com/ix-logo-horiz.svg'
                    alt='InvoiceXpress Logo'
                    className='logo mb-4'
                  />
                  <SubscriptionExpiredContent
                    currentFlow={currentFlow}
                    userAccounts={userAccounts}
                    selectedAccount={selectedAccount}
                    onAccountChange={handleAccountChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <Image
            src='https://invoicexpress-assets.s3.eu-west-1.amazonaws.com/ix_sad_standing.png'
            alt='Sad Characted Standing'
            className='position-absolute ix-sad-standing bottom-0'
          />
          <div className='d-flex flex-column justify-content-center faq-container-wrapper mb-5'>
            <div className='d-flex flex-column faq-container mb-4'>
              <Paragraph className='text-header h3'>
                {intl.messages['blockedPageFaqTitle_1']}
              </Paragraph>
              <Paragraph className='text-paragraph'>
                <FormattedMessage
                  id={`blockedPageFaqDescription_1_${currentFlow}`}
                  values={{
                    linebreak: <br />,
                  }}
                />
              </Paragraph>
            </div>
            <div className='d-flex flex-column faq-container'>
              <Paragraph className='text-header h3'>
                {intl.messages['blockedPageFaqTitle_2']}
              </Paragraph>
              <Paragraph className='text-paragraph'>
                <FormattedMessage
                  id={`blockedPageFaqDescription_2`}
                  values={{
                    linebreak: <br />,
                  }}
                />
              </Paragraph>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SubscriptionExpiredPage);
